import { X } from 'lucide-react';
import React from 'react';

interface Props {
  onClose: () => void;
  children: React.ReactNode;
}

export default function Modal(props: Props) {
  return (
    <div
      style={{
        display: 'flex',
        position: 'absolute',
        height: '100vh',
        width: '100vw',
        background: 'rgba(1, 1, 1, 0.3)',
        top: 0,
        left: 0,
        zIndex: 1000,
      }}
      onClick={(e) => {
        props.onClose();
      }}
    >
      <div
        style={{
          background: 'white',
          padding: '1rem',
          height: '50%',
          margin: 'auto',
          opacity: '100%',
          border: 'solid',
          borderColor: 'var(--global-gray-lighter-3)',
          borderWidth: '1px',
          borderRadius: '5px',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <X
          style={{
            borderRadius: '50%',
            width: '1rem',
            height: '1rem',
            margin: '5px 5px 0 auto',
          }}
          onClick={() => {
            props.onClose();
          }}
        />
        {props.children}
      </div>
    </div>
  );
}
